module.exports = __webpack_public_path__ + "static/img/icon-profile.42b36b4a.svg";